import http from "./http";

const post = (url, data) => http.post(url, Object.assign(data));

const get = (url, data) => http.get(url, Object.assign(data));

const getCommonParam = ({ key }) => get("/common/param", { key });

export {
    getCommonParam
};
